import { FC, memo } from 'react';
import { Typography } from 'antd';

import { useTranslate } from 'hooks';

import { ReactComponent as CheckEmail } from 'assets/icons/check-email.svg';

import s from './index.module.scss';

const ForgotPasswordCheckEmail: FC = memo(() => {
	const { checkEmailText, checkEmailMessageText } = useTranslate([
		'checkEmailText',
		'checkEmailMessageText',
	]);

	return (
		<>
			<CheckEmail className={s.icon} />

			<Typography.Title level={4}>{checkEmailText}</Typography.Title>
			<Typography.Text>{checkEmailMessageText}</Typography.Text>
		</>
	);
});

export { ForgotPasswordCheckEmail };
